import type { IDownloadIconProps } from './helpers';

export const DownloadIcon = ({ variant = 'default', ...props }: IDownloadIconProps) => {
	if (variant === 'plain')
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 18 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					d='M15.0289 7.46909H12.9102C11.1727 7.46909 9.75778 6.05417 9.75778 4.31668V2.19796C9.75778 1.79475 9.42788 1.46484 9.02466 1.46484H5.91624C3.65823 1.46484 1.83276 2.93108 1.83276 5.54832V12.0437C1.83276 14.661 3.65823 16.1272 5.91624 16.1272H11.6786C13.9366 16.1272 15.762 14.661 15.762 12.0437V8.20221C15.762 7.79899 15.4321 7.46909 15.0289 7.46909Z'
					fill='#566F83'
				/>
				<path
					d='M11.5833 1.61942C11.2827 1.31884 10.7622 1.52411 10.7622 1.94199V4.50057C10.7622 5.57093 11.6713 6.458 12.7783 6.458C13.4747 6.46533 14.4425 6.46533 15.2709 6.46533C15.6888 6.46533 15.9087 5.97414 15.6155 5.68089C14.5598 4.61787 12.6683 2.70443 11.5833 1.61942Z'
					fill='#566F83'
				/>
				<path
					d='M9.0027 10.793C8.7901 10.5804 8.4382 10.5804 8.2256 10.793L7.69775 11.3208V8.24906C7.69775 7.94848 7.44849 7.69922 7.14791 7.69922C6.84733 7.69922 6.59807 7.94848 6.59807 8.24906V11.3208L6.07023 10.793C5.85762 10.5804 5.50572 10.5804 5.29312 10.793C5.08052 11.0056 5.08052 11.3575 5.29312 11.5701L6.75936 13.0363C6.76669 13.0437 6.77402 13.0437 6.77402 13.051C6.81801 13.095 6.87666 13.1316 6.93531 13.161C7.00862 13.1829 7.0746 13.1976 7.14791 13.1976C7.22122 13.1976 7.2872 13.1829 7.35318 13.1536C7.41917 13.1243 7.47781 13.0876 7.53646 13.0363L9.0027 11.5701C9.21531 11.3575 9.21531 11.0056 9.0027 10.793Z'
					fill='#566F83'
				/>
			</svg>
		);

	return (
		<svg
			width='41'
			height='41'
			viewBox='0 0 41 41'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<rect
				x='0.5'
				y='0.5'
				width='40'
				height='40'
				rx='20'
				fill='#FFEEFF'
			/>
			<path
				opacity='0.4'
				d='M26.1665 19.2933H24.2398C22.6598 19.2933 21.3732 18.0066 21.3732 16.4266V14.4999C21.3732 14.1333 21.0732 13.8333 20.7065 13.8333H17.8798C15.8265 13.8333 14.1665 15.1666 14.1665 17.5466V23.4533C14.1665 25.8333 15.8265 27.1666 17.8798 27.1666H23.1198C25.1732 27.1666 26.8332 25.8333 26.8332 23.4533V19.9599C26.8332 19.5933 26.5332 19.2933 26.1665 19.2933Z'
				fill='#8B1169'
			/>
			<path
				d='M23.0333 13.9734C22.76 13.7001 22.2866 13.8867 22.2866 14.2667V16.5934C22.2866 17.5667 23.1133 18.3734 24.12 18.3734C24.7533 18.3801 25.6333 18.3801 26.3866 18.3801C26.7666 18.3801 26.9666 17.9334 26.7 17.6667C25.74 16.7001 24.02 14.9601 23.0333 13.9734Z'
				fill='#8B1169'
			/>
			<path
				d='M20.6868 22.3133C20.4935 22.12 20.1735 22.12 19.9801 22.3133L19.5001 22.7933V20C19.5001 19.7267 19.2735 19.5 19.0001 19.5C18.7268 19.5 18.5001 19.7267 18.5001 20V22.7933L18.0201 22.3133C17.8268 22.12 17.5068 22.12 17.3135 22.3133C17.1201 22.5067 17.1201 22.8267 17.3135 23.02L18.6468 24.3533C18.6535 24.36 18.6601 24.36 18.6601 24.3667C18.7001 24.4067 18.7535 24.44 18.8068 24.4667C18.8735 24.4867 18.9335 24.5 19.0001 24.5C19.0668 24.5 19.1268 24.4867 19.1868 24.46C19.2468 24.4333 19.3001 24.4 19.3535 24.3533L20.6868 23.02C20.8801 22.8267 20.8801 22.5067 20.6868 22.3133Z'
				fill='#8B1169'
			/>
		</svg>
	);
};
